<app-document-countries
  [name]="'Публичная оферта BusyFly Курьер'"
  [countries]="countries"
></app-document-countries>
